module.exports = __webpack_public_path__ + "img/snake.e67ad1df.png";